import Home from "./home/Home";
import { Routes, Route } from "react-router-dom";
import Portfolio from "../src/portfolio/Portfolio";
import Resume from "../src/resume/Resume";
import NavigationBar from "./Shared/NavigationBar";
import Contact from "./home/templates/components/Contact";
import EditHome from "./edit/edithome/EditHome";
import EditResume from "./edit/editresume/EditResume";
import EditPortfolio from "./edit/editportfolio/EditPortfolio";
import EditContact from "./edit/editcontact/EditContact";
import "./App.css";

function App() {
  return (
    <div className="App">
      <NavigationBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="portfolio" element={<Portfolio />} />
        <Route path="resume" element={<Resume />} />
        <Route path="contact" element={<Contact />} />
        <Route path="edithome" element={<EditHome />} />
        <Route path="editportfolio" element={<EditPortfolio />} />
        <Route path="editcontact" element={<EditContact />} />
        <Route path="editresume" element={<EditResume />} />
      </Routes>
    </div>
  );
}

export default App;
